import React, {useState} from 'react';
import {Link} from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
import VisiblePassword from '../../components/visiblePassword.js';
import UserError from '../../components/userError.js';
import GoogleAuthButton from '../../components/googleAuthButton.js'
import SuccessfullAccountCreation from '../../components/successfullAccountCreation.js'
import sharedPOST from '../../helpers/sharedFetch.js';
import {useLogin} from '../../helpers/loginContext.js';
import {useAuth} from '../../helpers/authContext.js';
import ConfirmEmailCode from '../ConfirmEmailCode/index.js'
import CreateAccount from '../CreateAccount/index.js'

import Login from '../Login/index.js';

import {APIResponse} from '../../../../server/routes/route-types.js'
import {RtApiResult} from '../../../../server/routes/user.js'


// Interface for user data from Google login
interface UserData {
    name: string;
    email: string;
}

// Interface for Google login success parameters
interface GoogleLoginSuccessParams {
    name: string;
    email: string;
    accountCreated: boolean;
}

// Interface for registration parameters
interface RegistrationParams {
    name: string;
    email: string;
    password: string;
    agreedWithTerms: boolean;
    captcha: string;
}

export default function Register() {

//	const [data, setPageData] = useState(pageData);
    const {setLoginType} = useLogin(); 
    const {setUser} = useAuth();
    const [showSuccessfullAccountCreation, setShowSuccessfullAccountCreation] = useState<boolean>(false);
    const [showAccountCreateDialog, setShowAccountCreateDialog] = useState<boolean>(false);
    const [userData, setUserData] = useState<UserData>({} as UserData)

    function handleRegisterSuccess(successMessage?: string) {
        setUser(true);
        console.log(` in handleRegisterSuccess`);
        setShowSuccessfullAccountCreation(true);
    }

    function handleGoogleLoginSuccess({name, email, accountCreated}: GoogleLoginSuccessParams) {

        if (!accountCreated) {
            setUserData({
                name,
                email
            })
            setShowAccountCreateDialog(true);
        }
        else {
            // account already created
            window.location.reload();
        }
    }

    function handleGoogleAccountCreated() {
        setShowSuccessfullAccountCreation(true)
    }

    if (showSuccessfullAccountCreation) {
        return (<SuccessfullAccountCreation message='You have successfully logged in and can now use your account. This page will refresh in a few seconds'/>
        )
    }
    if (showAccountCreateDialog) {
        return (
            <CreateAccount 
                name={userData.name} 
                email={userData.email} 
                onAccountCreated={handleGoogleAccountCreated} 
            />)
    }

	return (<>
        {/* <div className="row mt-5">
            <div className="col-md-5 m-auto">
                <div className="card card-body"> */}
                    <h4 className="text-center mb-3">
                        <b>
                            Create a Free Account!
                        </b>
                    </h4>   
                    <GoogleAuthButton buttonText='Sign up with Google' onSuccess={handleGoogleLoginSuccess}/>
                <SignUpWithEmailDivider/>
                <SignWithEmailForm onSuccessSignIn={handleRegisterSuccess}/>
                <HaveAccountDivider/>
                <HasAccountLogin/>
{/*
                </div>
           </div>
        </div>
    */}
    </>)
}

// Interface for RegisterGoogle props
interface RegisterGoogleProps {
    onSuccess: (data: GoogleLoginSuccessParams) => void;
}

function RegisterGoogle({onSuccess}: RegisterGoogleProps) {
    return (
        <div>
            <a href="/auth/google">
                <button className="btn btn-block">
                    <span className="fa fa-google"></span>
                    &nbsp;&nbsp;Sign up with Google
                </button>
            </a>
        </div>
    )
}

function SignUpWithEmailDivider() {
    return (
        <div className="or-line with-line ng-scope" >
            <div style={{textAlign: 'center'}}>
                <small>
                    Or sign up with email
                </small>
            </div>
        </div>
    )
}

// Interface for SignWithEmailForm props
interface SignWithEmailFormProps {
    onSuccessSignIn: (successMessage?: string) => void;
}

function SignWithEmailForm({onSuccessSignIn}: SignWithEmailFormProps) {

    const [flashProps, setFlashProps] = useState<FlashMessageData>({});
    const [userMessage, setUserMessage] = 
        useState<string>(`To register for our services, please use a professional email address. Accounts created with personal email addresses may be subject to additional security verification before submitting orders or initiating security scans.`);
    const recaptchaRef = React.createRef<ReCAPTCHA>();
    const [showConfirmEmailCodeForm, setShowConfirmEmailCodeForm] = useState<boolean>(false);

    function handleEmailLogin(params: RegistrationParams) {

        setUserMessage('');
        setFlashProps({})

        sharedPOST(
            '/user/register',
            {...params},
            {
                onSuccess: function (untypedResponse: unknown) {
                    const response = untypedResponse as APIResponse<RtApiResult>;
                    setFlashProps(response.results!);
                    setShowConfirmEmailCodeForm(true);  
                },
                onError: function (error: string) {
                    setFlashProps({error: error});
                }
            }
        )
    }

    function handleConfirmCode(emailCode: string) {

        setUserMessage('');
        setFlashProps({});
    
        sharedPOST(
            '/user/confirm-email-account-activate',
            {
                otpCode: emailCode
            },
            {
                onSuccess: function (untypedResponse: unknown) {
                    const response = untypedResponse as APIResponse<RtApiResult>;
                    setFlashProps(response.results!);
                    console.log(` before onSuccessSignIn`);
                    onSuccessSignIn();
                },
                onError: function (err: string) {
                    setFlashProps({error: err});
                }
            }
        )
    }
    
    return (
        <div>
            <div>
                <FlashMessages props={flashProps} />
                <UserError message={userMessage}/>
            </div>
            {
                showConfirmEmailCodeForm ?
                    <ConfirmEmailCode onConfirmCode={handleConfirmCode}/>
                :
                    <EmailRegistrationForm onSubmit={handleEmailLogin} />
            }
        </div>
    )
}

// Interface for EmailRegistrationForm props
interface EmailRegistrationFormProps {
    onSubmit: (params: RegistrationParams) => void;
}

function EmailRegistrationForm({onSubmit}: EmailRegistrationFormProps) {

    const recaptchaRef = React.createRef<ReCAPTCHA>();

    return (

        <form action="/user/register" onSubmit={handleSubmit}>
        {/* <form action="/user/register" onSubmit={handleSubmit}> */}
        <div className="form-group">
            <input
                type="name"
                id="name"
                name="name"
                className="form-control"
                placeholder="Profile Name"
            />
            </div>
            <div className="form-group">
            <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                placeholder="Email"
            />
            </div>
            <div className="form-group">
                <VisiblePassword id={"password"} />
            </div>
            <div className="form-group">
                <input 
                    type="checkbox" 
                    id="agreedWithTerms" 
                    name="agreedWithTerms"
                />
                {' '}
                <label htmlFor="agreeWithTerms"> 
                    <span>
                    I agree with{' '}
                    </span>
                    <Link 
                        to ="/terms" 
                        style={{textDecoration: 'underline'}} 
                        target={"_blank"}
                    > 
                        Terms and Conditions
                    </Link>
                </label>
                <br/>
            </div>
            {/* sitekey={data.ReCaptchaSiteKey} */}
            <div className="form-group">
                <ReCAPTCHA 
                    ref={recaptchaRef}
                    sitekey={window.wts_captcha_public_key!}
                />
            </div>
            <button type="submit" className="btn btn-primary btn-block">
                Sign Up
            </button>
        </form>
    )

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    
        event.preventDefault();
    
        const form = event.currentTarget;
        const nameElement = form.elements.namedItem('name') as HTMLInputElement;
        const emailElement = form.elements.namedItem('email') as HTMLInputElement;
        const passwordElement = form.elements.namedItem('password') as HTMLInputElement;
        const agreedWithTermsElement = form.elements.namedItem('agreedWithTerms') as HTMLInputElement;

        onSubmit({
            name: nameElement.value,
            email: emailElement.value,
            password: passwordElement.value,
            agreedWithTerms: agreedWithTermsElement.checked,
            captcha: recaptchaRef.current?.getValue() || ''
        })
    }
}

function HaveAccountDivider() {

    return (
        <div className="or-line with-line ng-scope" ><div style={{textAlign: 'center'}}><small>Or</small></div></div>
    )

}

function HasAccountLogin() {

    const {setLoginType} = useLogin();

    return (
        <>
            <p>Have an account?{' '}
                <a
                    className="link-hover"
                    style={{cursor: 'pointer'}} 
                    title={`Log In`}
                    // to={`#`}
                    onClick={(e) => {
                        e.preventDefault();
                        setLoginType((<Login />))}}
                >
                    <b>Log In</b>
                </a>	
            </p>
            <br />
        </>
    )
}
